import { VisitAndAppointmentView } from '@dreryk/egabinet-visit-frontend-api';
import { PatientReferenceIdentifier } from '@dreryk/egabinet-patient-published-language-api';

import { StatusIcon, StatusIconTooltip, Syncable, TooltipPlacement } from '@dreryk/react-components';

import { PatientEntitlementToMedicalServiceStatusVerification } from '~libs.shared.patient-entitlement-to-medical-service';

import { usePatientEntitlementToMedicalServiceStatusOptions } from './shared/usePatientEntitlementToMedicalServiceStatusOptions';
import { getPatientEntitlementToMedicalServiceStatusTooltipText } from './shared/getPatientEntitlementToMedicalServiceStatusTooltipText';
import { dispatchEwusPasswordDaysUntilExpirationSnackbarEvent } from './shared/dispatchEwusPasswordDaysUntilExpirationSnackbarEvent';
import { dispatchEwusPasswordExpiredSnackbarEvent } from './shared/dispatchEwusPasswordExpiredSnackbarEvent';
import { useEwusLoginModal } from './ewusLogin/useEwusLoginModal';

export type PatientEntitlementToMedicalServiceStatusIconProps = {
   readonly patientId: VisitAndAppointmentView['patientId'];
   readonly visitId: VisitAndAppointmentView['visitId'];
   readonly entitlementToMedicalService: VisitAndAppointmentView['entitlementToMedicalService'];
   readonly checkDate: Date;
   readonly patientReferenceIdentifier: PatientReferenceIdentifier | undefined;
   readonly readonly: boolean;
};

export const PatientEntitlementToMedicalServiceStatusIcon = (
   props: PatientEntitlementToMedicalServiceStatusIconProps
): JSX.Element => {
   const options = usePatientEntitlementToMedicalServiceStatusOptions();
   const { openEwusLoginModal, renderEwusLoginModal } = useEwusLoginModal();

   return (
      <PatientEntitlementToMedicalServiceStatusVerification
         patientId={props.patientId}
         visitId={props.visitId}
         checkDate={props.checkDate}
         initialStatus={props.entitlementToMedicalService}
         patientReferenceIdentifier={props.patientReferenceIdentifier}
         readonly={props.readonly}
         onEwusPasswordDaysUntilExpirationFault={dispatchEwusPasswordDaysUntilExpirationSnackbarEvent}
         onEwusPasswordExpiredFault={dispatchEwusPasswordExpiredSnackbarEvent}
         onEwusLoginRequired={openEwusLoginModal}
      >
         {({ verifyStatus, state }) => {
            const tooltipText = getPatientEntitlementToMedicalServiceStatusTooltipText(state);

            return (
               <>
                  <StatusIconTooltip
                     tooltipText={tooltipText}
                     tooltipPlacement={TooltipPlacement.LEFT}
                     testId={'ewusStatus'}
                  >
                     <Syncable inactive={!state.verifyAvailable} onClick={verifyStatus} testId={'ewusStatus'}>
                        <StatusIcon type={state.status} options={options} testId={'ewusStatus'} />
                     </Syncable>
                  </StatusIconTooltip>

                  {renderEwusLoginModal({
                     onLogin: verifyStatus,
                  })}
               </>
            );
         }}
      </PatientEntitlementToMedicalServiceStatusVerification>
   );
};
